import { render, staticRenderFns } from "./WarnBlock.vue?vue&type=template&id=e95c61f2&scoped=true"
import script from "./WarnBlock.vue?vue&type=script&lang=js"
export * from "./WarnBlock.vue?vue&type=script&lang=js"
import style0 from "./WarnBlock.vue?vue&type=style&index=0&id=e95c61f2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e95c61f2",
  null
  
)

export default component.exports